import { gql } from '@apollo/client';
import { apolloClient } from '~/apollo-client';

export const getSignupFunnelLead = async (
  params: GetSignupFunnelLeadParams,
): Promise<GetSignupFunnelLeadResponse> => {
  const { userId } = params;
  const query = gql`
    query GetSignupFunnelLeadData($userId: Int!) {
      user(id: $userId) {
        id
        signupFunnelLead {
          id
          utilityScreen
          userScreen
          enrollmentScreen
          utilityAccountsDetailsScreen
          mailingAddressScreen
          selfAttestationScreen
          legalScreen
          utilityConnectService
          lmiZoneVerificationService
          docusignService
          otherAttributes
          paymentScreen
          paymentService
        }
      }
    }
  `;
  const variables = {
    userId,
  };
  const { data } = await apolloClient.query({
    query,
    variables,
  });

  const signupFunnelLead = data?.user?.signupFunnelLead;

  return {
    id: signupFunnelLead?.id,
    userId: signupFunnelLead?.userId,
    utilityScreen: signupFunnelLead?.utilityScreen,
    userScreen: signupFunnelLead?.userScreen,
    enrollmentScreen: signupFunnelLead?.enrollmentScreen,
    utilityAccountsDetailsScreen: signupFunnelLead?.utilityAccountsDetailsScreen,
    mailingAddressScreen: signupFunnelLead?.mailingAddressScreen,
    selfAttestationScreen: signupFunnelLead?.selfAttestationScreen,
    legalScreen: signupFunnelLead?.legalScreen,
    utilityConnectService: signupFunnelLead?.utilityConnectService,
    lmiZoneVerificationService: signupFunnelLead?.lmiZoneVerificationService,
    docusignService: signupFunnelLead?.docusignService,
    otherAttributes: signupFunnelLead?.otherAttributes,
    paymentScreen: signupFunnelLead?.paymentScreen,
    paymentService: signupFunnelLead?.paymentService,
  };
};

export interface GetSignupFunnelLeadParams {
  userId: number;
}

export interface GetSignupFunnelLeadResponse {
  id?: number;
  userId?: number;
  utilityScreen?: any;
  userScreen?: any;
  enrollmentScreen?: any;
  utilityAccountsDetailsScreen?: any;
  mailingAddressScreen?: any;
  selfAttestationScreen?: any;
  legalScreen?: any;
  utilityConnectService?: any;
  lmiZoneVerificationService?: any;
  docusignService?: any;
  otherAttributes?: any;
  paymentScreen?: any;
  paymentService?: any;
}
